
import { defineComponent, ref } from 'vue'
import {
  useMessage,
  NButton,
  NModal,
  NForm,
  NFormItem,
  NInput,
  NIcon,
  NSwitch,
} from 'naive-ui'
import { API } from '@/api/api'
import { CreateOutline } from '@vicons/ionicons5'

export default defineComponent({
  components: {
    NButton,
    NModal,
    NForm,
    NFormItem,
    NInput,
    NIcon,
    CreateOutline,
    NSwitch,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    emitUpdate: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const message = useMessage()
    const showModal = ref(false)
    const model = ref({
      titulo: null,
      status: true,
      descricao: null,
      detalhamento: false,
      diretorio: null,
    })

    async function updateData() {
      try {
        const data = {
          ...model.value,
        }

        const response = await API().put(
          `/dashboard/subgrupos/${props.data.id}`,
          data
        )

        if (response.status === 200) {
          message.success('Subgrupo atualizado com sucesso!')
          props.emitUpdate()
          showModal.value = false
        } else {
          message.error(
            'Erro ao atualizar subgrupo, verifique se os dados estão corretos e tente novamente mais tarde'
          )
        }
      } catch (error) {
        console.error(error)
        message.error(
          'Erro interno - Tente novamente mais tarde e contate o suporte.'
        )
      }
    }

    function openModal() {
      showModal.value = true
      model.value = {
        titulo: props.data.titulo,
        status: props.data.status == 1 ? true : false,
        descricao: props.data.descricao,
        detalhamento: props.data.detalhamento,
        diretorio: props.data.diretorio,
      }
    }

    return {
      model,
      showModal,
      updateData,
      openModal,
    }
  },
})
